import cn from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';

import CMSCard from '../CMSCard/CMSCard';

import styles from './GenericCategories.module.scss';

function Categories({ page = 1, categories = [], contentName, categoryTitle }) {
  if (!categories.length) return null;

  const router = useRouter();

  return (
    <CMSCard>
      <h5 className={styles.title}>{categoryTitle || 'Κατηγορίες'}</h5>
      <div className={styles.categories}>
        {categories.map(category => (
          <Link key={category.uuid} href={`/${contentName}?page=${page}&category=${category.slug}`}>
            <a className={cn({ [styles.active]: router.asPath.includes(category.slug) })}>
              <i className="mdi mdi-chevron-right" />
              {category.title}
            </a>
          </Link>
        ))}
      </div>
    </CMSCard>
  );
}

export default Categories;
